import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { ShoppingCart } from "lucide-react";

const LOGO_URL =
    "https://customer-assets.emergentagent.com/job_bazaar-staging-1/artifacts/vzvsn7zl_bharatbazaar_512.png";

export const Logo = ({ size = 36, withWordmark = true, light = false }) => {
    const location = useLocation();
    const navigate = useNavigate();

    const handleClick = (e) => {
        e.preventDefault();
        if (location.pathname !== "/") {
            navigate("/");
        }
        // Notify Shop to reset mobile view back to category landing
        window.dispatchEvent(new CustomEvent("bazaar:home"));
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    return (
        <Link
            to="/"
            onClick={handleClick}
            className="flex items-center gap-2.5 group"
            data-testid="brand-logo"
        >
            <img
                src={LOGO_URL}
                alt="BharatBazaar logo"
                style={{ width: size, height: size }}
                className="rounded-lg transition-transform duration-300 group-hover:rotate-[-6deg]"
            />
            {withWordmark && (
                <div className="flex flex-col leading-none">
                    <span
                        className={`font-display text-[1.35rem] font-semibold tracking-tight ${
                            light ? "text-white" : "text-[#1a1a1a]"
                        }`}
                    >
                        my<span className="text-[#FF5722]">BazaarCart</span>
                    </span>
                    <span
                        className={`text-[10px] font-medium tracking-[0.18em] uppercase mt-0.5 ${
                            light ? "text-white/50" : "text-[#6B7280]"
                        }`}
                    >
                        mybazaarcart.com
                    </span>
                </div>
            )}
        </Link>
    );
};

export const CartBadge = ({ count = 0 }) => (
    <button
        data-testid="cart-icon-button"
        className="relative h-11 w-11 rounded-full bg-white border border-neutral-200 hover:border-[#FF5722] hover:shadow-md flex items-center justify-center transition-all duration-300"
        aria-label="Cart"
    >
        <ShoppingCart className="h-5 w-5 text-[#1a1a1a]" strokeWidth={2.25} />
        {count > 0 && (
            <span className="absolute -top-1 -right-1 h-5 w-5 rounded-full bg-[#FF5722] text-white text-[10px] font-bold flex items-center justify-center">
                {count}
            </span>
        )}
    </button>
);
